import { ORDER_STATUS_LABEL, ORDER_STATUS_COLOR, type OrderStatus } from '../../model/types'

export function StatusBadge({ status }: { status: OrderStatus }) {
  return (
    <span className={[
      'inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-semibold',
      ORDER_STATUS_COLOR[status],
    ].join(' ')}>
      {ORDER_STATUS_LABEL[status]}
    </span>
  )
}
